<template>
  <v-content
    class="base"
  >
    <v-container fluid full-height class="my-8 mt-0">
      <v-layout
        justify-center
      >
        <div
          class="bg"
        >
          <img
            :src="bg"
          />
        </div>
        <div style="z-index:100">
          <img
            :src="content.image"
            class="image"
          />
          <div
            class="msg1"
            v-html="content.msg1"
          ></div>
          <div
            class="msg2"
            v-html="content.msg2"
          ></div>
          <div class="stepper">
            <template
              v-for="i in 4"
            >
              <svg :key="`o${i}`" v-if="content.no == i" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="5" cy="5" r="4.5" fill="#FF5500" stroke="#FF5500"/>
              </svg>
              <svg :key="`g${i}`" v-else width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="#D3D2D2"/>
              </svg>
              <div
                :key="`s${i}`"
                v-if="i < 4"
                style="display: inline-block; width: 8px;"
              ></div>
            </template>
          </div>
          <div
            @click="$router.push(content.next)"
            class="button"
            :class="content.no == 4 ? 'button-last' : ''"
          >{{ content.button }}</div>
        </div>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data: () => ({
    bg: require('@/assets/images/onboarding/bg.svg'),
    content: {
      no: 0,
      image: require('@/assets/images/onboarding/b1.png'),
      msg1: '',
      msg2: '',
      button: '',
      next: '',
    },
    contents: {
      b1: {
        no: 1,
        image: require('@/assets/images/onboarding/b1.png'),
        msg1: 'Find Paikers',
        msg2: 'who share your passion 🌐️',
        button: 'OK',
        next: '/onBoarding/b2',
      },
      b2: {
        no: 2,
        image: require('@/assets/images/onboarding/b2.png'),
        msg1: 'Collect likes across the world',
        msg2: 'by sharing your passion🧡',
        button: 'Got it!',
        next: '/onBoarding/b3',
      },
      b3: {
        no: 3,
        image: require('@/assets/images/onboarding/b3.png'),
        msg1: 'Chat',
        msg2: 'with Paikers through messages📩',
        button: 'Cool!',
        next: '/onBoarding/b4',
      },
      b4: {
        no: 4,
        image: require('@/assets/images/onboarding/b4.png'),
        msg1: 'Paike out',
        msg2: 'when traveling in the future.<br />Your passion🧡> Language skills✏️',
        button: `Excited!`,
        next: '/likes',
      },
    }
  }),
  async mounted() {
    this.setData(this.$route)
  },
  watch: {
    '$route' (to) {
      this.setData(to)
    },
  },
  methods: {
    setData(route) {
      const page = route.params.page
      this.content = this.contents[page]
    },
  },
}
</script>

<style lang="stylus" scoped>
.base
  background-color #FAFAFA
  height 100%

div.bg
  position absolute
  width 100%
  height 100%
  overflow hidden
  img
    position absolute
    top -55px
    left 50%
    transform translate(-50%)
    z-index 1

img.image
  display block
  height 332px
  width 212px
  margin 45px auto 0 auto
  border-radius 24px
  z-index 100

div.button
  width 144px
  height 48px
  line-height 45px
  text-align center
  color #FF5500
  font-size 18px
  font-weight bold
  background #FFFFFF
  border 2px solid #FF5500
  border-radius 16px
  cursor pointer
  margin 0 auto

div.button-last
  width 180px
  color white
  background #FF5500

div.stepper
  text-align center
  line-height 48px
  height 48px

div.msg1
  font-style normal
  font-weight bold
  font-size 26px
  line-height 35px
  text-align center
  color #0C0B0B

div.msg2
  height 56px
  font-style normal
  font-weight normal
  font-size 22px
  line-height 28px
  text-align center
  color #0C0B0B

</style>
